import { InjectionToken } from '@angular/core';

import { WebsocketOptions } from './websocket.entity';

export const WEBSOCKET_OPTIONS: InjectionToken<WebsocketOptions> = new InjectionToken('WEBSOCKET_OPTIONS');

export function provideWebsocketClientOptions(options: Partial<WebsocketOptions>) {
  return {
    provide: WEBSOCKET_OPTIONS,
    useValue: {
      reconnectInterval: 5000,
      reconnectAttempts: 10,
      pingInterval: 5000,
      timeout: 8000,
      typeKey: 'type',
      deserializer: (e: MessageEvent) => JSON.parse(e.data),
      serializer: (value: any) => JSON.stringify(value),
      ...options
    }
  };
}